import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'

export interface EmptyProps extends HTMLAttributes<HTMLDivElement> {
  /** Serif, and it says what is not here rather than apologising for it. */
  title: string
  children?: ReactNode
}

/** Nothing to show, said once and in one shape. Dashed border so it reads as a
 *  place something will be, not as a card that failed to load. */
export const Empty = forwardRef<HTMLDivElement, EmptyProps>(function Empty(
  { title, className = '', children, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={`u-empty ${className}`.trim()} {...rest}>
      <p className="u-empty__title">{title}</p>
      {children && <div className="u-empty__body">{children}</div>}
    </div>
  )
})
